import React from 'react';

import LogoutButtonView from '@components/LogoutButton/LogoutButtonView';
import { useMytaverse } from '@providers/MytaverseProvider';
import ConfirmLogoutModal, {
  useOpenConfirmLogoutModal,
} from '@components/ConfirmLogoutModal';
import { ILogoutButtonProps } from '@components/LogoutButton/interfaces';

const DashboardLogoutButton = ({ sx = {} }: ILogoutButtonProps) => {
  const { user } = useMytaverse();

  const {
    open: isOpenedConfirmLogoutModal,
    openModal: onOpenConfirmLogoutModal,
    closeModal: onCloseConfirmLogoutModal,
  } = useOpenConfirmLogoutModal();

  if (!user) {
    return null;
  }

  return (
    <>
      <LogoutButtonView logoutUser={onOpenConfirmLogoutModal} sx={sx} />

      <ConfirmLogoutModal
        open={isOpenedConfirmLogoutModal}
        onClose={onCloseConfirmLogoutModal}
      />
    </>
  );
};

export default DashboardLogoutButton;
